export default function KpiTile({ icon: Icon, label, value, hint }) {
  return (
    <div className="card">
      <div className="flex items-start justify-between">
        <div>
          <div className="text-xs uppercase tracking-wider text-stone-500">
            {label}
          </div>
          <div className="mt-2 text-3xl font-serif text-alfred-cream">
            {value}
          </div>
          {hint && <div className="mt-1 text-xs text-stone-500">{hint}</div>}
        </div>
        {Icon && (
          <div className="rounded-full border border-alfred-gold/40 bg-alfred-gold/10 p-2 text-alfred-gold">
            <Icon size={18} />
          </div>
        )}
      </div>
    </div>
  );
}
